import { useTheme } from '../../../context/ThemeContext';
import AwardYears from '../../../components/Awards/AwardYears';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCommon } from '../../../Hooks/Common/useCommon';

const Awards = () => {

    const { getValuePermission } = useCommon();
    const { theme } = useTheme();
    const [filterValues, setFilterValues] = useState({ apiCall: true, tab: "years_and_categories" });
    const tabs = [
        { key: "years_and_categories", label: "Years & Categories" },
        { key: "winners", label: "Winners" },
    ]

    return (!getValuePermission("awards_tab") &&
        <div className='px-2 pt-2'>
            <div className='d-flex justify-content-between align-items-center'>
                {/* <div className={`tab-menu ${theme === "dark" ? "dark" : ""}`}>
                    {tabs?.map(item => (
                        <div key={item?.key} className={`tab-menu-item ${item?.key === filterValues?.tab ? `active${theme === "dark" ? "-dark" : ""}` : ""}`} onClick={() => setFilterValues((prev) => ({ ...prev, tab: item?.key, apiCall: true }))}>
                            {item?.label}
                        </div>
                    ))}
                </div> */}
                <div></div>
                <div>
                    <button className='sk-btn sk-btn-primary' onClick={() => setFilterValues((prev) => ({ ...prev, apiCall: true }))}><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
                </div>
            </div>
            {filterValues?.tab === "years_and_categories" ?
                <AwardYears filterValues={filterValues} setFilterValues={setFilterValues} /> : <></>
            }
        </div>
    )
}

export default Awards